import React, { useState } from 'react';

import { useTranslation } from 'react-i18next';
import styled from 'styled-components';
import { useContainer } from 'unstated-next';

import { ClassContainer } from './ClassContainer';
import { StyledLoadingButton as LoadingButton } from '../../components/forms/LoadingButton';
import { ClassStatus } from '../../context/types';

const StyledLoadingButton = styled(LoadingButton)`
    margin-left: 0.75rem;
`;

const SaveAsDraftButton = styled(LoadingButton)`
    margin-left: 0.75rem;

    .MuiLoadingButton-loadingIndicatorCenter {
        color: ${(props) => props.theme.colors.primary.main};
    }
`;

export interface ClassSubmitButtonProps {
    admin?: boolean;
    onSuccess?: () => void;
}

const ClassSubmitButtons = (props: ClassSubmitButtonProps) => {
    const { onSuccess, admin = false } = props;
    const { t } = useTranslation('create_edit_class');

    const [isCreatingClass, setIsCreatingClass] = useState(false);
    const [isCreatingDraft, setIsCreatingDraft] = useState(false);
    const [isUpdatingClass, setIsUpdatingClass] = useState(false);

    const { handleSubmit, formActionType, createClass, updateClass, setValue } = useContainer(ClassContainer);

    const handleCreateDraft = async () => {
        setIsCreatingDraft(true);

        setValue('status', ClassStatus.Draft);
        await createClass({ onSuccess });

        setIsCreatingDraft(false);
    };

    const handleCreateClass = async () => {
        setIsCreatingClass(true);

        await createClass({ onSuccess });

        setIsCreatingClass(false);
    };

    const handleUpdateClass = async () => {
        setIsUpdatingClass(true);

        await updateClass({ onSuccess });

        setIsUpdatingClass(false);
    };

    if (admin) {
        return (
            <span>
                <SaveAsDraftButton
                    variant="outlined"
                    onClick={handleSubmit(handleCreateDraft)}
                    disabled={isCreatingDraft}
                    loading={isCreatingDraft}
                >
                    {t('save-as-draft')}
                </SaveAsDraftButton>
                <StyledLoadingButton
                    variant="contained"
                    onClick={handleSubmit(handleCreateClass)}
                    disabled={isCreatingClass}
                    loading={isCreatingClass}
                >
                    {t('schedule')}
                </StyledLoadingButton>
            </span>
        );
    }

    if (formActionType === 'CREATE') {
        return (
            <StyledLoadingButton
                variant="contained"
                onClick={handleSubmit(handleCreateClass)}
                disabled={isCreatingClass}
                loading={isCreatingClass}
            >
                {t('schedule')}
            </StyledLoadingButton>
        );
    }

    if (formActionType === 'EDIT') {
        return (
            <StyledLoadingButton
                variant="contained"
                onClick={handleSubmit(handleUpdateClass)}
                disabled={isUpdatingClass}
                loading={isUpdatingClass}
            >
                {t('save')}
            </StyledLoadingButton>
        );
    }

    return null;
};

export default ClassSubmitButtons;
